import React, { Component } from 'react'
import Icon from 'components/icon/icon'
import { connect } from 'react-redux'
import { withRouter } from 'react-router'
import { updateFolderChain } from 'state/actions'

class ProjectBreadcrumbs extends Component {
	constructor(props){
		super(props);

		this.folderCrumbs = []
		this.parentFolders = []
	}

	getFolderChain = _ => {
		const {
			currentProject,
			allFolders,
			type,
			milestone
		} = this.props

		let project = currentProject

		if(project){
			let hasReachedRoot = false
			let IdIterator = project.folder_id

			let safetyIterator = 0

			let folderChainArray = []

			while(hasReachedRoot === false){
				let folderObject = allFolders[IdIterator]

				if(folderObject){
					folderObject.crumbType = 'folder'
					folderChainArray.push(folderObject)

					if(folderObject.folder_id){
						IdIterator = folderObject.folder_id
					}else{
						hasReachedRoot = true
					}
				}

				safetyIterator++
				if(safetyIterator > 10){
					hasReachedRoot = true
				}
			}

			this.parentFolders = folderChainArray

			folderChainArray = [...folderChainArray]

			this.folderCrumbs = folderChainArray.reverse()

			if(type === 'task'){
				project.crumbType = 'project'

				this.folderCrumbs.push(project)

				if(milestone){
					let milestoneCrumb = {
						crumbType: 'project',
						milestone,
						name: milestone.name
					}
	
					this.folderCrumbs.push(milestoneCrumb)
				}
			}
		}
	}

	onCrumbClick = (crumb, index) => {
		const {
			history,
			currentAccount,
			currentProject,
			updateFolderChain,
		} = this.props

		if(crumb.crumbType === 'folder'){
			history.push('/'+currentAccount.slug+'/projects')
			let tempFolderChain = []

			this.parentFolders.forEach(folder => {
				if(folder.crumbType === 'folder'){
					tempFolderChain.push(folder.id)
				}
			})

			tempFolderChain.reverse()

			tempFolderChain.length = (index + 1)
			updateFolderChain(tempFolderChain)
		}else{
			let projectUrl = `/${currentAccount.slug}/projects/${currentProject.slug}/tasks`

			if(crumb.milestone){
				projectUrl += `?milestone=${ crumb.milestone.id }`
			}

			history.push(projectUrl)
		}
	}

	render(){
		this.getFolderChain()

		return(
			<ul className="folder-breadcrumbs">
				<li>
					<Icon name="folder-o" />
				</li>
				{
					this.folderCrumbs.map((folder, i) => {
						return (
							<li 
								key={i} 
								className='folder' 
								onClick={_ => {this.onCrumbClick(folder, i)}}
							>
								<span>
									&rsaquo;
								</span>
								<button>
									{
										folder.is_root ?
										'Projects'
										:
										folder.name 
									}
								</button>
							</li>
						)
					})
				}
			</ul>
		)
	}
}

const mapStateToProps = state => {  
    return {
        allFolders: state.account.entities.folders,
    }
}

export default withRouter(connect(mapStateToProps, {updateFolderChain})(ProjectBreadcrumbs));  